module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("如何实现"), _c('code', [_vm._v("weui.io")]), _vm._v("或者星巴克页面的设置顶部bar和页面下拉背景色")]), _vm._v(" "), _c('p', [_vm._v("微信对于部分合作方开放了"), _c('code', [_vm._v("jssdk")]), _vm._v("的"), _c('code', [_vm._v("setBounceBackground")]), _vm._v("及"), _c('code', [_vm._v("setNavigationBarColor")]), _vm._v("权限，目测暂无申请入口。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7db3e4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-e7db3e4c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/other-186.vue
// module id = 2463
// module chunks = 415